import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
 
import axios from "../../../utils/axios";
import {
    CALL_PPOR_API,
    MIDDLE_WARE_BASE_URL_v1,
} from "../../../utils/CONSTANTS";
 
const initialState = {
    getheaderfooterState: '',
    getheaderfooterData: '',
};
export const getheaderfooter : any = createAsyncThunk(
    "get/getheaderfooter",
    async (data: any) => {
        const response = axios.postStringRequest(
            MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
            data
        );
        return response;
    }
);
 
 
const getheaderfooterSlice = createSlice({
    name: "getheaderfooter",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getheaderfooter.pending, (state) => {
                state.getheaderfooterState = "pending";
            })
            .addCase(getheaderfooter.fulfilled, (state, action) => {
                let tempRes = action.payload.data?.response;
                if (typeof tempRes === "string") {
                    tempRes = JSON.parse(tempRes);
                    // console.log(tempRes + "tempRes");
                }
                state.getheaderfooterState = "fulfilled";
                state.getheaderfooterData = tempRes?.response?.header;
                // console.log("getheaderfooterData", state.getheaderfooterData);
            })
            .addCase(getheaderfooter.rejected, (state) => {
                state.getheaderfooterState = "failed";
            })
});
 
export const getheaderfooters = (state: any) => state.getheaderfooter;
 
export default getheaderfooterSlice.reducer;
 
 